import * as types from '../actionType'

const initialState = []

const userUpdateAddress = (state = initialState, action) => {
    switch (action.type) {
        case types.USER_UPDATE_ADDRESS:
            return action.payload
        default:
            return state
    }
}


export { userUpdateAddress }